import React from "react";
import * as ReactDOM from "react-dom/client";
import { System } from "./component/system";
var DOMContainer = document.querySelector("#like_system");
var root = ReactDOM.createRoot(DOMContainer);
function renderElement() {
    var elem = <System />;
    root.render(elem);
}
renderElement();
